export { default } from './BlockDiagonalDivider';
